import React, { Component } from 'react';
import styles from './TagManager.module.css';
import PropTypes from 'prop-types';
import TableView from '../../components/TableView';
import { connect } from 'react-redux';
import { getTags, fetchTags, createTag, deleteTag } from '../../modules/tags';
import ReactSelect from 'react-select';

class TagManager extends Component {
  state = {
    header: [''],
    error: null,
    tagAction: null,
    selectedTags: [],
    selected: {},
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  createTag = async () => {
    const { createTag } = this.props;
    const name = this.refs['tagName'].value;
    const tag = await createTag(name);
    if (tag.status && tag.status === 'failed') {
      this.setState({ error: tag.message });
      return;
    }
    this.refs['tagName'].value = '';
    this.setState({ error: null });
  };

  async componentDidMount() {
    const { fetchTags } = this.props;
    await fetchTags();
  }

  setTagAction = data => {
    this.setState({ tagAction: data && data.value });
  };

  executeAction = async () => {
    const { tagAction, selected } = this.state;
    const { deleteTag } = this.props;
    const keys = Object.keys(selected);
    if (!tagAction || keys.length === 0) return;
    if (tagAction === 'delete') {
      await deleteTag(keys);
    }
  };

  onSelect = (id, value) => {
    const { selected } = this.state;
    if (value) {
      selected[id] = value;
    } else {
      delete selected[id];
    }
    this.setState({ selected });
  };

  render() {
    const { header, error, tagAction, selected } = this.state;
    const { tags } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.header}>Tag Manager</div>
        <div className={styles.content}>
          <div className={styles.leftContainer}>
            <div className={styles.description}>
              Tags are a way to combine groups of collections, models, materials
              and/or scenes. Create a new tag by selecting one or more choices
              from these categories
            </div>
            <div className={styles.title}>Create New Tag</div>
            <div className={styles.inputTitle}>
              Tag Name*{' '}
              <span className={styles.required}>Required, must be unique</span>
            </div>
            <div className={styles.searchTagContainer}>
              <input
                ref="tagName"
                className={styles.searchTag}
                placeholder="Enter tag name here"
              />
              <button className={styles.upload} onClick={this.createTag}>
                Create Tag
              </button>
            </div>
            {error && <div className={styles.errorTxt}>{error}</div>}
          </div>
          <div className={styles.rightContainer}>
            <div className={styles.title}> Current Tags </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <ReactSelect
                value={tagAction}
                onChange={this.setTagAction}
                className={styles.tagDropdown}
                placeholder="Select Action"
                options={[{ label: 'Delete', value: 'delete' }]}
              />
              <button className={styles.upload} onClick={this.executeAction}>
                Apply
              </button>
            </div>
            <div className={styles.tagContainer}>
              <TableView
                selected={selected}
                headers={header}
                rowColor="#2375C2"
                font="light"
                onSelect={this.onSelect}
                data={tags}
                hiderHiderCheckbox={true}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const stateToProps = state => ({
  tags: getTags(state),
});

export default connect(
  stateToProps,
  { fetchTags, createTag, deleteTag }
)(TagManager);



// WEBPACK FOOTER //
// ./src/containers/TagManger/index.js